import { render, staticRenderFns } from "./PublicActivitiesNews.vue?vue&type=template&id=55c09936&scoped=true"
import script from "./PublicActivitiesNews.vue?vue&type=script&lang=js"
export * from "./PublicActivitiesNews.vue?vue&type=script&lang=js"
import style0 from "./PublicActivitiesNews.vue?vue&type=style&index=0&id=55c09936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c09936",
  null
  
)

export default component.exports